module.exports = __webpack_public_path__ + "img/sec5_5.27fd62f9.jpg";